import { BillStatus } from "@redotech/crdb-enums/billing/bill-status";
import { BillType } from "@redotech/crdb-enums/billing/bill-type";
import {
  billStatusLabels,
  getBillTypeLabel,
  subscriptionProductLabels,
} from "@redotech/redo-billing-common/billing-display-labels";
import { SubscriptionProduct } from "@redotech/redo-billing-common/unified-billing/enums";
import FileCheck02 from "@redotech/redo-icons/file-check-02.svg";
import PackageIcon from "@redotech/redo-icons/package.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-views-common/advanced-filters/generic-advanced-filter-data";
import type {
  AdvancedTableFilter,
  ArrayStringTableFilter,
} from "@redotech/redo-web/advanced-filters/advanced-filter";

export const INVOICE_FILTER_NAME_STATUS = "status";
export const INVOICE_FILTER_NAME_PRODUCT = "product";
export const INVOICE_FILTER_NAME_TYPE = "type";

export const statusFilter: ArrayStringTableFilter<BillStatus> = {
  type: AdvancedFilterType.ARRAY_TO_STRING,
  Icon: FileCheck02,
  displayName: "Status",
  itemLabel: "status",
  itemLabelPlural: "statuses",
  values: Object.values(BillStatus),
  display: (item: BillStatus) => billStatusLabels[item],
  data: {
    name: INVOICE_FILTER_NAME_STATUS,
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: undefined,
    operator: ArrayStringFilterOperator.ANY_OF,
  },
};

export const productFilter: ArrayStringTableFilter<SubscriptionProduct> = {
  type: AdvancedFilterType.ARRAY_TO_STRING,
  Icon: PackageIcon,
  displayName: "Product",
  itemLabel: "product",
  itemLabelPlural: "products",
  values: Object.values(SubscriptionProduct),
  display: (item: SubscriptionProduct) => subscriptionProductLabels[item],
  data: {
    name: INVOICE_FILTER_NAME_PRODUCT,
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: undefined,
    operator: ArrayStringFilterOperator.ANY_OF,
  },
};

// Non-ledger bill types the Invoices table shows; Shipping is the ledger, shown
// in Statements.
const typeFilter: ArrayStringTableFilter<BillType> = {
  type: AdvancedFilterType.ARRAY_TO_STRING,
  Icon: PackageIcon,
  displayName: "Type",
  itemLabel: "type",
  itemLabelPlural: "types",
  values: [BillType.Software, BillType.ReturnShipping, BillType.PurchaseOrder],
  display: (item: BillType) => getBillTypeLabel(item),
  data: {
    name: INVOICE_FILTER_NAME_TYPE,
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: undefined,
    operator: ArrayStringFilterOperator.ANY_OF,
  },
};

// The billed-date scope lives in the summary card's date-range picker, not here
// — two date filters on one table intersected into confusing results.
export const INVOICE_ADVANCED_FILTERS: AdvancedTableFilter[] = [
  statusFilter,
  productFilter,
  typeFilter,
];
